import { Api } from '../api';
import { profile } from '../endpoints';
import type { ApiResponse } from '../../models';
import type { ProfileFeaturesResponse, ProfileResponse, UpdateAddressRequest } from './models';

export class ProfileApi extends Api {
  static getProfile = (signal?: AbortSignal) => this.get<ApiResponse<ProfileResponse>>({ url: profile.getProfile(), signal });

  static getProfileFeatures = (signal?: AbortSignal) => this.get<ApiResponse<ProfileFeaturesResponse>>({ url: profile.getProfileFeatures(), signal });

  static updateAddress = (data: UpdateAddressRequest, signal?: AbortSignal) =>
    this.put<UpdateAddressRequest, ApiResponse<string>>({ url: profile.updateAddress(), data, signal });
}
